export enum SyllabusTaskTypes {
    Videos = 'Videos',
    Modules = 'Modules',
    Labs = 'Labs',
    ChalkTalks = 'Chalk Talks',
    OfficeHours='Office Hours',
    LabSessions='Lab Sessions'
}